export default __webpack_public_path__ + "_/images/bonuses/bonuses-card/gift-92faac8e801ed8140f512709dec770e7583efd88ab0e107f2eb1016fe6c029bd.png";